import { createSelector, Selector } from 'reselect'

import { BRANCH_KEY, IAnalyticsOwnState, IAnalyticsState } from './model'

export const branch: Selector<IAnalyticsOwnState, IAnalyticsState> = (state) => state[BRANCH_KEY].analytics

export const context = createSelector(branch, (analytics) => analytics.context)
